export default __webpack_public_path__ + "static/media/kanban.6b031eb6.png";